import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { CustomLoader } from "../CustomLoader";
import { CommonButton } from "./commonButton";
import {
  primaryButtonStyle,
  primaryButtonHoverColor,
  secondaryButtonStyle,
} from "./commonButtonStyles";

function DialogBox({
  title,
  body,
  child,
  confirmText,
  deleteBtnText,
  cancelText = "Cancel",
  isOpen,
  onCancel,
  onConfirm,
  isDisableConfirm = false,
  showConfirmButton = true,
  contentWidth = 300,
  deletePopup,
  width = "100%",
  loading = false
}) {
  return (
    <Dialog open={isOpen} onClose={onCancel} onBackdropClick="false">
      <DialogTitle>{title}</DialogTitle>
      {loading ? (
        <div
          style={{ minWidth: contentWidth, width: "100%", minHeight: "100px" }}
        >
          <CustomLoader />
        </div>
      ) : (
        <>
          <DialogContent style={{ minWidth: contentWidth, width: "100%" }}>
            <div>
              <DialogContentText>{body}</DialogContentText>
            {(() => {
              try {
                return typeof child === "function" ? child() : child;
              } catch {
                return null;
              }
            })()}
            </div>
          </DialogContent>
          <DialogActions style={{ padding: "0 20px 20px" }}>
            <CommonButton
              text={cancelText}
              handleClick={onCancel}
              sx={secondaryButtonStyle}
            />
            {deleteBtnText && (
              <Button
                onClick={deletePopup}
                size="medium"
                style={{ padding: "15px 0px", borderRadius: "13px" }}
              >
                {deleteBtnText}
              </Button>
            )}
            {showConfirmButton && (
              <CommonButton
                text={confirmText}
                handleClick={onConfirm}
                disabled={isDisableConfirm}
                sx={primaryButtonStyle}
                hoverColor={primaryButtonHoverColor}
              />
            )}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}

export default DialogBox;
